
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/akcie/[campaign]/[[...parameters]]",
      function () {
        return require("private-next-pages/akcie/[campaign]/[[...parameters]].js");
      }
    ]);
  